// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"715":"0a8577ab","954":"a9c71a1e"}[chunkId] + ".chunk.css";
};